import { Box, Typography } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

interface WarningMessageProps {
  message: string
  className?: string
  "data-testid"?: string
}

export const WarningMessage: FC<WarningMessageProps> = ({ message, className, "data-testid": testId }) => {
  return (
    <Box className={twMerge("flex flex-row items-center gap-1", className)} data-testid={testId}>
      <WarningOutlined fontSize='small' color='warning' />
      <Typography variant='caption' sx={{ color: "#663C00" }}>
        {message}
      </Typography>
    </Box>
  )
}
